"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasetDataApi = exports.DatasetDataApiFactory = exports.DatasetDataApiFp = exports.DatasetDataApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * DatasetDataApi - axios parameter creator
 * @export
 */
const DatasetDataApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {Array<DatasetIdentifier>} datasetIdentifier
         * @param {boolean} [all]
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataResourceClearData: (datasetIdentifier_1, all_1, from_1, to_1, ...args_1) => __awaiter(this, [datasetIdentifier_1, all_1, from_1, to_1, ...args_1], void 0, function* (datasetIdentifier, all, from, to, options = {}) {
            // verify required parameter 'datasetIdentifier' is not null or undefined
            (0, common_1.assertParamExists)('datasetDataResourceClearData', 'datasetIdentifier', datasetIdentifier);
            const localVarPath = `/datasetData/clearData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (all !== undefined) {
                localVarQueryParameter['all'] = all;
            }
            if (from !== undefined) {
                for (const [key, value] of Object.entries(from)) {
                    localVarQueryParameter[key] = value;
                }
            }
            if (to !== undefined) {
                for (const [key, value] of Object.entries(to)) {
                    localVarQueryParameter[key] = value;
                }
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(datasetIdentifier, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [from]
         * @param {string} [to]
         * @param {Array<string> | null} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataResourceGetDataInfoRange: (from_2, to_2, requestBody_1, ...args_2) => __awaiter(this, [from_2, to_2, requestBody_1, ...args_2], void 0, function* (from, to, requestBody, options = {}) {
            const localVarPath = `/datasetData/dataInfoRange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (from !== undefined) {
                for (const [key, value] of Object.entries(from)) {
                    localVarQueryParameter[key] = value;
                }
            }
            if (to !== undefined) {
                for (const [key, value] of Object.entries(to)) {
                    localVarQueryParameter[key] = value;
                }
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [count]
         * @param {string} [refTime]
         * @param {boolean} [strict]
         * @param {Array<DatasetIdentifier> | null} [datasetIdentifier]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataResourceGetDataInfoRecent: (count_1, refTime_1, strict_1, datasetIdentifier_2, ...args_3) => __awaiter(this, [count_1, refTime_1, strict_1, datasetIdentifier_2, ...args_3], void 0, function* (count, refTime, strict, datasetIdentifier, options = {}) {
            const localVarPath = `/datasetData/dataInfoRecent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }
            if (refTime !== undefined) {
                for (const [key, value] of Object.entries(refTime)) {
                    localVarQueryParameter[key] = value;
                }
            }
            if (strict !== undefined) {
                localVarQueryParameter['strict'] = strict;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(datasetIdentifier, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} from
         * @param {string} to
         * @param {object | null} [aggregationPeriod]
         * @param {{ [key: string]: AggregationType; } | null} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataResourceGetDatasetDataAggregated: (from_3, to_3, aggregationPeriod_1, requestBody_2, ...args_4) => __awaiter(this, [from_3, to_3, aggregationPeriod_1, requestBody_2, ...args_4], void 0, function* (from, to, aggregationPeriod, requestBody, options = {}) {
            // verify required parameter 'from' is not null or undefined
            (0, common_1.assertParamExists)('datasetDataResourceGetDatasetDataAggregated', 'from', from);
            // verify required parameter 'to' is not null or undefined
            (0, common_1.assertParamExists)('datasetDataResourceGetDatasetDataAggregated', 'to', to);
            const localVarPath = `/datasetData/dataAggregatedInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (aggregationPeriod !== undefined) {
                for (const [key, value] of Object.entries(aggregationPeriod)) {
                    localVarQueryParameter[key] = value;
                }
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString() :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString() :
                    to;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<UpdateDatasetData>} updateDatasetData
         * @param {boolean} [log]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataResourceUpdateDatasetData: (updateDatasetData_1, log_1, ...args_5) => __awaiter(this, [updateDatasetData_1, log_1, ...args_5], void 0, function* (updateDatasetData, log, options = {}) {
            // verify required parameter 'updateDatasetData' is not null or undefined
            (0, common_1.assertParamExists)('datasetDataResourceUpdateDatasetData', 'updateDatasetData', updateDatasetData);
            const localVarPath = `/datasetData/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (log !== undefined) {
                localVarQueryParameter['log'] = log;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateDatasetData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.DatasetDataApiAxiosParamCreator = DatasetDataApiAxiosParamCreator;
/**
 * DatasetDataApi - functional programming interface
 * @export
 */
const DatasetDataApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DatasetDataApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {Array<DatasetIdentifier>} datasetIdentifier
         * @param {boolean} [all]
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataResourceClearData(datasetIdentifier, all, from, to, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetDataResourceClearData(datasetIdentifier, all, from, to, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetDataApi.datasetDataResourceClearData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [from]
         * @param {string} [to]
         * @param {Array<string> | null} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataResourceGetDataInfoRange(from, to, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetDataResourceGetDataInfoRange(from, to, requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetDataApi.datasetDataResourceGetDataInfoRange']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [count]
         * @param {string} [refTime]
         * @param {boolean} [strict]
         * @param {Array<DatasetIdentifier> | null} [datasetIdentifier]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataResourceGetDataInfoRecent(count, refTime, strict, datasetIdentifier, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetDataResourceGetDataInfoRecent(count, refTime, strict, datasetIdentifier, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetDataApi.datasetDataResourceGetDataInfoRecent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} from
         * @param {string} to
         * @param {object | null} [aggregationPeriod]
         * @param {{ [key: string]: AggregationType; } | null} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataResourceGetDatasetDataAggregated(from, to, aggregationPeriod, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetDataResourceGetDatasetDataAggregated(from, to, aggregationPeriod, requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetDataApi.datasetDataResourceGetDatasetDataAggregated']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<UpdateDatasetData>} updateDatasetData
         * @param {boolean} [log]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataResourceUpdateDatasetData(updateDatasetData, log, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetDataResourceUpdateDatasetData(updateDatasetData, log, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetDataApi.datasetDataResourceUpdateDatasetData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.DatasetDataApiFp = DatasetDataApiFp;
/**
 * DatasetDataApi - factory interface
 * @export
 */
const DatasetDataApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DatasetDataApiFp)(configuration);
    return {
        /**
         *
         * @param {DatasetDataApiDatasetDataResourceClearDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataResourceClearData(requestParameters, options) {
            return localVarFp.datasetDataResourceClearData(requestParameters.datasetIdentifier, requestParameters.all, requestParameters.from, requestParameters.to, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetDataApiDatasetDataResourceGetDataInfoRangeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataResourceGetDataInfoRange(requestParameters = {}, options) {
            return localVarFp.datasetDataResourceGetDataInfoRange(requestParameters.from, requestParameters.to, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetDataApiDatasetDataResourceGetDataInfoRecentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataResourceGetDataInfoRecent(requestParameters = {}, options) {
            return localVarFp.datasetDataResourceGetDataInfoRecent(requestParameters.count, requestParameters.refTime, requestParameters.strict, requestParameters.datasetIdentifier, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetDataApiDatasetDataResourceGetDatasetDataAggregatedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataResourceGetDatasetDataAggregated(requestParameters, options) {
            return localVarFp.datasetDataResourceGetDatasetDataAggregated(requestParameters.from, requestParameters.to, requestParameters.aggregationPeriod, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetDataApiDatasetDataResourceUpdateDatasetDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataResourceUpdateDatasetData(requestParameters, options) {
            return localVarFp.datasetDataResourceUpdateDatasetData(requestParameters.updateDatasetData, requestParameters.log, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DatasetDataApiFactory = DatasetDataApiFactory;
/**
 * DatasetDataApi - object-oriented interface
 * @export
 * @class DatasetDataApi
 * @extends {BaseAPI}
 */
class DatasetDataApi extends base_1.BaseAPI {
    /**
     *
     * @param {DatasetDataApiDatasetDataResourceClearDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetDataApi
     */
    datasetDataResourceClearData(requestParameters, options) {
        return (0, exports.DatasetDataApiFp)(this.configuration).datasetDataResourceClearData(requestParameters.datasetIdentifier, requestParameters.all, requestParameters.from, requestParameters.to, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetDataApiDatasetDataResourceGetDataInfoRangeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetDataApi
     */
    datasetDataResourceGetDataInfoRange(requestParameters = {}, options) {
        return (0, exports.DatasetDataApiFp)(this.configuration).datasetDataResourceGetDataInfoRange(requestParameters.from, requestParameters.to, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetDataApiDatasetDataResourceGetDataInfoRecentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetDataApi
     */
    datasetDataResourceGetDataInfoRecent(requestParameters = {}, options) {
        return (0, exports.DatasetDataApiFp)(this.configuration).datasetDataResourceGetDataInfoRecent(requestParameters.count, requestParameters.refTime, requestParameters.strict, requestParameters.datasetIdentifier, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetDataApiDatasetDataResourceGetDatasetDataAggregatedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetDataApi
     */
    datasetDataResourceGetDatasetDataAggregated(requestParameters, options) {
        return (0, exports.DatasetDataApiFp)(this.configuration).datasetDataResourceGetDatasetDataAggregated(requestParameters.from, requestParameters.to, requestParameters.aggregationPeriod, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetDataApiDatasetDataResourceUpdateDatasetDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetDataApi
     */
    datasetDataResourceUpdateDatasetData(requestParameters, options) {
        return (0, exports.DatasetDataApiFp)(this.configuration).datasetDataResourceUpdateDatasetData(requestParameters.updateDatasetData, requestParameters.log, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DatasetDataApi = DatasetDataApi;
//# sourceMappingURL=dataset-data-api.js.map